import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { put } from 'utils/http'

export const useCustomerEnrichApiQuotaReset = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const resetQuota = () => put(`/management/customers/${customerId}/enrich_api/quota/reset`)

  return useMutation({
    mutationFn: resetQuota,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'enrich_api_quota'] })

      addNotification('Enrich API quota has been reset')
    },
  })
}
